const modulesFiles = require.context('./', true, /app\.view\.js/);

export const routes = modulesFiles.keys().reduce((routes, modulePath) => {
    const primaryPath = modulePath.split('/')[1];
    const split = primaryPath.includes('-') ? primaryPath.split('-') : [primaryPath];
    let moduleName = split[0][0].toUpperCase() + split[0].slice(1);
    if (split.length > 1) {
        for (let i = 1; i < split.length; i++) {
            moduleName += split[i][0].toUpperCase() + split[i].slice(1);
        }
    }
    const module = modulesFiles(modulePath);
    const layout = module.layout;
    const meta = module.meta || {};
    const modules = {
        path: '', // 空路径
        component: layout, // 空路径对应加载页面指定layout
        children: [{
            name: moduleName,
            path: `/${primaryPath}`, // 页面的路径
            component: module[moduleName], // 页面vue
            meta: { ...meta }
        }]
    };
    routes.push(modules);
    return routes;
}, []);
